module.exports = __webpack_public_path__ + "img/6.7893da56.png";